import { Dispatch, SetStateAction } from 'react';
import styled, { css } from 'styled-components';

import { theme } from 'theme';
import { Hub } from '@shared/enums/hub';
import { device } from '@styles/mediaQuery';
import { hubButtons } from '@shared/constants/hubs';
import { ArticleHeader, Button } from '@components/atoms';
import LocationLight from '@public/icons/location-white.svg';
import LocationDark from '@public/icons/location-dark.svg';

type HubSelectorProps = {
  hub: Hub;
  setHub: Dispatch<SetStateAction<Hub>>;
};

function HubSelector({ hub, setHub }: HubSelectorProps) {
  return (
    <Wrapper>
      <ArticleHeader title="Our Terminals" fontSizeL="36px" />

      <Divider />

      {hubButtons.map((button) => {
        const selected = button.id === hub;
        const bgColor = selected ? 'forestGreen' : 'white';
        const color = selected ? 'white' : 'textPrimary';
        const icon = selected ? LocationLight : LocationDark;

        return (
          <Button
            key={button.title}
            id={button.id}
            setStateAction={setHub}
            height="45px"
            width="100%"
            fontSize="18px"
            title={button.title}
            bgColor={bgColor}
            color={color}
            padding="0 0 0 15px"
            margin="0 0 15px"
            justifyContent="flex-start"
            Icon={icon}
            shadow={`0px 1px 3px ${theme.colors.divider}`}
            gradient={selected}
          />
        );
      })}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.divider};
  border-radius: 16px;

  ${device.laptopS(css`
    height: 542px;
    width: 340px;
    margin-left: 40px;
    padding: 30px;
    min-width: 280px;
  `)}
`;

const Divider = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.divider};
  height: 1px;
  margin: 16px auto;
`;

export default HubSelector;
